module.exports = __webpack_public_path__ + "static/Resume-6abc8826adbd30a106c97ac9d53e37ea.pdf";